module.exports = __webpack_public_path__ + "img/payment-promise (1).20fa288.svg";